import {ANALYZERS_ROUTES} from "@constants"
import {offices, reports, searchID} from "@signals"

import PageWrapper from "Pages/@PageWrapper"
import {resetCustomFilters, responseData} from "Pages/AnalyzersV2/@signals"
import BrokersContent from "Pages/AnalyzersV2/Brokers/Content"
import BrokersFilters from "Pages/AnalyzersV2/Brokers/Filters"
import React, {useEffect, useState} from "react"
import {createPortal} from "react-dom"
import {useSearchParams, useLocation} from "react-router-dom"
import {useSearchDate} from "../@hooks";
import {Box, Skeleton, Typography} from "@mui/material";
import {AppOfficesBlock} from "../../../@components";
import PageWrapperAnalyzers from "../../@PageWrapper/Actions/Analyzers";
import ReportsAutocomplete from "../../@PageWrapper/Actions/Reports";
import VirtualTourButton, {TourOverlay, TOUR_STEPS} from "./VirtualTour";
import BrokersDemoData from "./VirtualTour/DemoData";
import { AnalyzerEvolutionModal } from "Pages/AnalyzersV2/@components";
import { demoPopoverOpen } from "./VirtualTour/signals";


export default function BrokersAnalyzer() {

	const [ searchParams ] = useSearchParams()
	const location = useLocation()
	const { date, office, isLoading } = useSearchDate()
	const [tourActive, setTourActive] = useState(false)

	useEffect(() => {
		resetCustomFilters()
		searchID.value = searchParams.get("idSearch")
		reports.value = searchParams.get("idReportExecution")
		offices.value = searchParams.get("idOfficePickup")
	}, [location.search])

	return <PageWrapper
		directsite={false}
		head={`DS Rentacar | ${ANALYZERS_ROUTES.BROKERS_SUBTITLE}`}
		title={ANALYZERS_ROUTES.TITLE}
		subtitle={ANALYZERS_ROUTES.BROKERS_SUBTITLE}
		showAnalyzersLinks={true}
        // possible bug showReportSelect
		isEmpty={false}
		filters={<BrokersFilters/>}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
			{!searchID.value && <Box sx={{ minWidth: 300, mr: 2 }}>
				<ReportsAutocomplete directsite={false}/>
			</Box>}
			{!!searchID.value && <>
				{isLoading
					? <Skeleton variant='rectangular' height={30} />
					: <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: 2, color: 'secondary.main' }}>
						<AppOfficesBlock sx={{ color: 'black' }} {...office}  /> -
						<Typography variant="subtitle2" fontWeight='regular'>{date}</Typography>
					</Box>}
			</>}
			<PageWrapperAnalyzers/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		<BrokersContent/>
		{tourActive && !Object.keys(responseData.value || {}).length && <BrokersDemoData/>}
		{tourActive && !Object.keys(responseData.value || {}).length && <AnalyzerEvolutionModal/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => {
				demoPopoverOpen.value = false
				setTourActive(false)
			}} />,
			document.body
		)}
	</PageWrapper>
}
